<template>
  <div class="old-union">
    <div
      v-if="noticeData && noticeData.noticeContent"
      class="notice"
    >
      <div class="notice__wrapper">
        <notice
          :noticeData="noticeData"
          :unionHead="unionHead"
          :noticeInit="noticeInit"
        >
          <span
            slot="noticeLabel"
            class="notice__label"
          >
            <i class="notice__icon"></i>
          </span>
        </notice>
      </div>
    </div>
    <old-union-bar
      v-if="unionHead && loginData"
      :unionHead="unionHead"
      :loginData="loginData"
    ></old-union-bar>
    <old-union-body
      v-if="unionHead"
      :unionHead="unionHead"
    ></old-union-body>
    <old-union-menu
      v-if="unionHead"
      :unionHead="unionHead"
    ></old-union-menu>
  </div>
</template>

<script>
import OldUnionBar from './OldUnionBar';
import OldUnionBody from './OldUnionBody';
import OldUnionMenu from './OldUnionMenu';

export default {
  components: {
    OldUnionBar,
    OldUnionBody,
    OldUnionMenu,
    Notice: () => import('./Notice'),
  },
  data() {
    return {
      unionHead: null,
      loginData: null,
      noticeData: null,
      noticeInit: {
        color: '#666',
        col1: 1,
        col2: 23,
      },
    };
  },
  created() {
    // 获取公告内容
    this.getNoticeData();

    // 获取登录状态
    this.getLoginStatus();

    // 获取老工会信息
    this.getLogo();
  },
  methods: {
    getLogo() {
      this.apis.headerApi.getLogo().then(res => {
        this.unionHead = res;
      });
    },
    getLoginStatus() {
      this.apis.headerApi.getLoginStatus().then(res => {
        sessionStorage.setItem('loginInfo', JSON.stringify(res));
        if (res.loginFlag) {
          this.loginData = res;
        } else {
          window.location.href = res.loginUrl;
        }
      });
    },
    getNoticeData() {
      this.apis.headerApi.getNotice().then(res => {
        this.noticeData = res;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.notice {
  height: 40px;
  line-height: 40px;
  background-color: #ebf5fa;
  &__wrapper {
    .wrapper();
  }
  &__label {
    > span {
      margin-left: 5px;
      font-size: 14px;
    }
  }
  &__icon {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -2px;
    background: url("./imgs/notice.png") no-repeat;
    width: 19px;
    height: 17px;
    background-size: cover;
  }
}
</style>
